module.exports = __webpack_public_path__ + "static/other/organize_desk_game_desk_2.023d56ea.json";


//////////////////
// WEBPACK FOOTER
// ./src/assets/qci/maps/organizeDeskGame/organize_desk_game_desk_2.json
// module id = 2350
// module chunks = 0